var React = require('react');
var createReactClass = require('create-react-class');
var PropTypes = require('prop-types');

var DEFAULT_PROFILE_IMAGE_URL = '/coaches/Content/images/CoachProfile/default-profile-photo.jpg';

var SearchResult = createReactClass({
	propTypes: {
		onProfileView: PropTypes.func.isRequired
	},

	componentDidMount: function() {
		$('a', this.searchResult).click(function() {});
	},

	summaryTeaser: function(teaserMaxLength) {
		var teaser = '';
		if (this.props.result.summaryText) {
			var words = this.props.result.summaryText.split(' ');

			if (this.props.result.summaryText.length <= teaserMaxLength) {
				return this.props.result.summaryText;
			}

			while (teaser.length < teaserMaxLength) {
				var nextWord = words.shift();
				if (nextWord !== undefined && teaser.length + nextWord.length < teaserMaxLength) {
					teaser += ' ' + nextWord;
				} else {
					break;
				}
			}

			if (this.props.result.summaryText.length > teaserMaxLength) {
				teaser += '...';
			}
		}
		return teaser;
	},

	getProfileUrl: function(slug) {
		return location.origin + '/coach/' + slug;
	},

	getPricingUrl: function(slug) {
		return this.getProfileUrl(slug) + '#pricing';
	},

	handlePricingButtonClick: function() {},

	renderProfileImage: function() {
		return (
			<a href={this.getProfileUrl(this.props.result.profileSlug)} onClick={this.props.onProfileView}>
				<img
					src={this.props.result.profileImage ? this.props.result.profileImage : DEFAULT_PROFILE_IMAGE_URL}
					alt={this.props.result.fullName}
					title={this.props.result.fullName}
				/>
			</a>
		);
	},

	renderSubTitle: function() {
		var subTitleParts = [];
		var addressParts = [];

		var result = this.props.result;

		if (result.companyName) {
			subTitleParts.push(result.companyName);
		}

		if (result.city) {
			addressParts.push(result.city);
		}

		if (result.state) {
			addressParts.push(result.state);
		}

		if (result.country && result.country !== 'US') {
			addressParts.push(result.countryName ? result.countryName : result.country);
		}

		return (
			<div>
				<div className="show-for-medium">
					<h5 className="profile-company-name u-text-base">{subTitleParts.concat(addressParts).join(', ')}</h5>
				</div>
				<div className="show-for-small-only">
					<h5 className="profile-company-name u-text-base">
						{subTitleParts.length > 0 ? (
							<span className="profile-company-name">
								{subTitleParts[0]}
								<br />
							</span>
						) : null}
						{addressParts.join(', ')}
					</h5>
				</div>
			</div>
		);
	},

	renderCertificationBanner: function() {
		if (!this.props.result.trainingPeaksCertificationLevel) {
			return;
		}

		var imageName =
			'/coaches/Content/images/search/level-' + this.props.result.trainingPeaksCertificationLevel + '.svg';

		return (
			<div className="certification-overlay">
				<img src={imageName} />
			</div>
		);
	},

	renderPricingButton: function(availableCoachMatchLevels, pricingUrl) {
		if (!availableCoachMatchLevels || availableCoachMatchLevels.length === 0) {
			return;
		}

		return (
			<a href={pricingUrl} className="button green expanded" onClick={this.handlePricingButtonClick}>
				Pricing
			</a>
		);
	},

	renderProfileButton: function(profileUrl) {
		return (
			<a href={profileUrl} className="button expanded" onClick={this.props.onProfileView}>
				View Profile
			</a>
		);
	},

	render: function() {
		var desktopSummaryTeaser = this.summaryTeaser(300);
		var mobileSummaryTeaser = this.summaryTeaser(175);

		var profileUrl = this.getProfileUrl(this.props.result.profileSlug);
		var pricingUrl = this.getPricingUrl(this.props.result.profileSlug);

		return (
			<div className="row">
				<div className="columns medium-12 show-for-medium">
					<div className="panel search-card" ref={(ref) => (this.searchResult = ref)}>
						<div className="row">
							<div className="columns medium-3">
								{this.renderCertificationBanner()}
								<div className="profile-image">{this.renderProfileImage()}</div>
							</div>
							<div className="columns medium-9 search-card-body">
								<h4 className="profile-full-name u-text-2xl">{this.props.result.fullName}</h4>
								{this.renderSubTitle()}
								<hr />
								<div className="row">
									<div className="columns medium-9">
										<div className="profile-summary">{desktopSummaryTeaser}</div>
									</div>
									<div className="columns medium-3">
										{this.renderProfileButton(profileUrl)}
										{this.renderPricingButton(
											this.props.result.availableCoachMatchLevels,
											pricingUrl
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="columns small-12 show-for-small-only">
					<div className="panel search-card">
						<div className="row">
							<div className="columns small-3">
								{this.renderCertificationBanner()}
								<div className="profile-image">{this.renderProfileImage()}</div>
							</div>
							<div className="columns small-9">
								<h4 className="profile-full-name u-text-2xl">{this.props.result.fullName}</h4>
								{this.renderSubTitle()}
							</div>
							<div className="columns small-12">
								<hr />
							</div>
							<div className="columns small-12">
								<div className="profile-summary">{mobileSummaryTeaser}</div>
							</div>
							<div className="columns small-12">
								<div className="row">
									<div className="columns small-12">{this.renderProfileButton(profileUrl)}</div>
								</div>
								<div className="row margin-top-10">
									<div className="columns small-12">
										{this.renderPricingButton(
											this.props.result.availableCoachMatchLevels,
											pricingUrl
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
});

module.exports = SearchResult;
